module.exports = __webpack_public_path__ + "static/toronto_photo-b29671b910f8ebe4c133a43973d5edd4.jpg";